import { agendaItemsCube, applicantPipelineCube, attendanceRecordsCube, boardHealthCube, bodyApplicantsCube, campaignApplicationsCube, departmentLegislativeActivityCube, departmentsCube, jointMeetingBodiesCube, legislativeDocumentTrackerCube, legislativeItemsCube, legislativeItemWorkflowsCube, legislativeStatusesCube, legislativeTypesCube, legislativeWorkflowPipelineCube, mediaArchivesCube, meetingAgendaWorkloadCube, meetingBodiesCube, meetingBodyCategoriesCube, meetingBodyPositionsCube, meetingBodySeatsCube, meetingBodySeatTermsCube, meetingComplianceCube, meetingEventDocumentsCube, meetingMembersCube, meetingsCube, meetingViewershipCube, memberRosterCube, minutesTrackerCube, seatApplicationsCube, seatApplicationTemplatesCube, seatApplicationWorkflowsCube, seatApplicationWorkflowStepsCube, seatCampaignsCube, seatRecruitmentCube, usersCube, voteRecordsCube, } from './cubes/index.js';
const filterOperatorMeta = {
    afterDate: { label: 'after', valueShape: 'single' },
    beforeDate: { label: 'before', valueShape: 'single' },
    contains: { label: 'contains', valueShape: 'single' },
    equals: { label: '=', valueShape: 'single' },
    gt: { label: '>', valueShape: 'single' },
    gte: { label: '≥', valueShape: 'single' },
    in: { label: 'in', valueShape: 'list' },
    inCurrentMonth: { label: 'this month', valueShape: 'none' },
    inCurrentQuarter: { label: 'this quarter', valueShape: 'none' },
    inCurrentYear: { label: 'this year', valueShape: 'none' },
    inDateRange: { label: 'in date range', valueShape: 'range' },
    lastMonth: { label: 'last month', valueShape: 'none' },
    lastNDays: { label: 'last N days', valueShape: 'number' },
    lastQuarter: { label: 'last quarter', valueShape: 'none' },
    lastWeek: { label: 'last week', valueShape: 'none' },
    lastYear: { label: 'last year', valueShape: 'none' },
    lt: { label: '<', valueShape: 'single' },
    lte: { label: '≤', valueShape: 'single' },
    notContains: { label: 'not contains', valueShape: 'single' },
    notEquals: { label: '≠', valueShape: 'single' },
    notIn: { label: 'not in', valueShape: 'list' },
    notInDateRange: { label: 'not in date range', valueShape: 'range' },
    notSet: { label: 'is not set', valueShape: 'none' },
    set: { label: 'is set', valueShape: 'none' },
    thisWeek: { label: 'this week', valueShape: 'none' },
    withinNextDays: { label: 'next N days', valueShape: 'number' },
};
const filterOperatorsByType = {
    boolean: ['equals', 'notEquals', 'set', 'notSet'],
    date: [
        'equals',
        'notEquals',
        'beforeDate',
        'afterDate',
        'inDateRange',
        'notInDateRange',
        'inCurrentMonth',
        'inCurrentQuarter',
        'inCurrentYear',
        'thisWeek',
        'lastWeek',
        'lastMonth',
        'lastQuarter',
        'lastYear',
        'lastNDays',
        'withinNextDays',
        'set',
        'notSet',
    ],
    number: ['equals', 'notEquals', 'gt', 'gte', 'lt', 'lte', 'in', 'notIn', 'set', 'notSet'],
    string: ['equals', 'notEquals', 'contains', 'notContains', 'in', 'notIn', 'set', 'notSet'],
};
const timeGranularities = [
    'day',
    'week',
    'month',
    'quarter',
    'year',
];
const tenantMemberByCube = {
    // Wave 1: Tenure
    agenda_items: 'meetings.government_id',
    applicant_pipeline: 'seat_applications.government_id',
    board_health: 'meeting_bodies.government_id',
    body_applicants: 'seat_applications.government_id',
    campaign_applications: 'seat_applications.government_id',
    joint_meeting_bodies: 'joint_meeting_bodies.government_id',
    legislative_items: 'legislative_items.government_id',
    meeting_bodies: 'meeting_bodies.government_id',
    meeting_body_categories: 'meeting_body_categories.government_id',
    meeting_body_positions: 'meeting_body_positions.government_id',
    meeting_body_seats: 'meeting_bodies.government_id',
    meeting_body_seat_terms: 'meeting_bodies.government_id',
    meeting_members: 'meeting_members.government_id',
    member_roster: 'meeting_bodies.government_id',
    seat_application_templates: 'seat_application_templates.government_id',
    seat_application_workflow_steps: 'seat_application_workflows.government_id',
    seat_application_workflows: 'seat_application_workflows.government_id',
    seat_applications: 'seat_applications.government_id',
    seat_campaigns: 'seat_campaigns.government_id',
    seat_recruitment: 'meeting_bodies.government_id',
    // Wave 2: Legislative / Meeting Lifecycle — Base
    departments: 'departments.government_id',
    legislative_item_workflow_templates: 'legislative_item_workflow_templates.government_id',
    legislative_statuses: 'legislative_statuses.government_id',
    legislative_types: 'legislative_types.government_id',
    media_archives: 'meetings.government_id',
    meeting_event_documents: 'meetings.government_id',
    meetings: 'meetings.government_id',
    users: 'users.government_id',
    // Wave 2: Legislative / Meeting Lifecycle — Combination
    department_legislative_activity: 'meetings.government_id',
    legislative_document_tracker: 'meetings.government_id',
    legislative_workflow_pipeline: 'meetings.government_id',
    meeting_agenda_workload: 'meetings.government_id',
    meeting_compliance: 'meeting_bodies.government_id',
    meeting_viewership: 'meeting_viewership.government_id',
    minutes_tracker: 'minutes_tracker.government_id',
    // Wave 3: Minutes Records
    attendance_records: 'meetings.government_id',
    vote_records: 'meetings.government_id',
};
export const reportCubeCatalog = {
    cubes: {
        // Wave 1: Tenure
        agenda_items: agendaItemsCube,
        applicant_pipeline: applicantPipelineCube,
        board_health: boardHealthCube,
        body_applicants: bodyApplicantsCube,
        campaign_applications: campaignApplicationsCube,
        joint_meeting_bodies: jointMeetingBodiesCube,
        legislative_items: legislativeItemsCube,
        meeting_bodies: meetingBodiesCube,
        meeting_body_categories: meetingBodyCategoriesCube,
        meeting_body_positions: meetingBodyPositionsCube,
        meeting_body_seats: meetingBodySeatsCube,
        meeting_body_seat_terms: meetingBodySeatTermsCube,
        meeting_members: meetingMembersCube,
        member_roster: memberRosterCube,
        seat_application_templates: seatApplicationTemplatesCube,
        seat_application_workflow_steps: seatApplicationWorkflowStepsCube,
        seat_application_workflows: seatApplicationWorkflowsCube,
        seat_applications: seatApplicationsCube,
        seat_campaigns: seatCampaignsCube,
        seat_recruitment: seatRecruitmentCube,
        // Wave 2: Legislative / Meeting Lifecycle — Base
        departments: departmentsCube,
        legislative_item_workflow_templates: legislativeItemWorkflowsCube,
        legislative_statuses: legislativeStatusesCube,
        legislative_types: legislativeTypesCube,
        media_archives: mediaArchivesCube,
        meeting_event_documents: meetingEventDocumentsCube,
        meetings: meetingsCube,
        users: usersCube,
        // Wave 2: Legislative / Meeting Lifecycle — Combination
        department_legislative_activity: departmentLegislativeActivityCube,
        legislative_document_tracker: legislativeDocumentTrackerCube,
        legislative_workflow_pipeline: legislativeWorkflowPipelineCube,
        meeting_agenda_workload: meetingAgendaWorkloadCube,
        meeting_compliance: meetingComplianceCube,
        meeting_viewership: meetingViewershipCube,
        minutes_tracker: minutesTrackerCube,
        // Wave 3: Minutes Records
        attendance_records: attendanceRecordsCube,
        vote_records: voteRecordsCube,
    },
    filterOperatorMeta,
    filterOperators: Object.keys(filterOperatorMeta),
    filterOperatorsByType,
    tenant: {
        memberByCube: tenantMemberByCube,
    },
    timeGranularities,
};
